import { changeMasUser, getAllMasusers } from '@/api/su/mas';
import { IMas, IMasUser } from '@/api/types';
import { IThunkAPI } from '@/store/types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const initialState: IMas = {
  isMasFetching: false,
  isMasSuccess: false,
  isMasError: false,
  masUsers: null,
};

export const getMasUsers = createAsyncThunk<IMasUser[], number, IThunkAPI>(
  'get/masUsers',
  async (clientId, thunkAPI) => {
    try {
      const response = await getAllMasusers(clientId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const changeAssignedMasUser = createAsyncThunk<
  boolean,
  { applicationId: number; newMasUserId: number },
  IThunkAPI
>('change/masUser', async ({ applicationId, newMasUserId }, thunkAPI) => {
  try {
    const response = await changeMasUser(applicationId, newMasUserId);
    return response.data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});

export const masSlice = createSlice({
  name: 'mas',
  initialState,
  reducers: {
    clearMasUsers(state) {
      state.masUsers = null;
      state.isMasError = false;
      state.isMasFetching = false;
      state.isMasSuccess = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getMasUsers.fulfilled, (state, action) => {
        state.isMasError = false;
        state.isMasFetching = false;
        state.isMasSuccess = true;
        state.masUsers = action.payload;
      })
      .addCase(getMasUsers.pending, state => {
        state.isMasError = false;
        state.isMasSuccess = false;
        state.isMasFetching = true;
      })
      .addCase(getMasUsers.rejected, state => {
        state.isMasError = true;
        state.isMasFetching = false;
        state.isMasSuccess = false;
      });
  },
});

//actions
export const { clearMasUsers } = masSlice.actions;

export default masSlice.reducer;
